export default {"src":"/_next/static/media/PediatricTumors.265363e5.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};